import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";
import {
  vendordataSelector,
  vendordata_updateFiles
} from "reducers/vendordata/vendordata";

function FileUploader() {
  const vendordata = useSelector(vendordataSelector);
  const dispatch = useDispatch();

  const onDrop = useCallback(acceptedFiles => {
    var uploadedfiles = [];
    console.log("drop, accepted", acceptedFiles, uploadedfiles);
    var cnt = acceptedFiles.length;
    var ctr = 1;
    let file_num = Object.keys(vendordata.files).length + 1;

    acceptedFiles.forEach(file => {
      console.log("go file", file);
      if (file["type"] == "application/pdf") {
        if (!file["content"]) {
          const reader = new FileReader();

          reader.onabort = () => console.log("file reading was aborted");
          reader.onerror = () => console.log("file reading has failed");
          reader.onload = e => {
            let i = e.currentTarget.result.indexOf(",") + 1;
            let sub = e.currentTarget.result.substr(i);

            file.FILE_CONTENT = sub;

            let realdate = new Date(parseInt(file.lastModified));

            let m = parseInt(realdate.getMonth()) + 1
            if (m < 10) {
              m = "0" + m;
            }

            let d = parseInt(realdate.getDate())
            if (d < 10) {
              d = "0" + d;
            }
            let usedate = realdate.getFullYear() + "" + m + "" + d;


            //file.CHG_DATE = file.lastModified;
            file.CHG_DATE = usedate;
            file.FILE_TYPE = "pdf"; // only pdf is allowed, so this is hardcoded, SAP expects types like 'pdf' not 'application/pdf' (AJ)
            file.FILE_NUM = file_num; //Object.keys(this.props.files).length + 1;
            file.FILE_NAME = file.name; //after upgrade to Node24, react-dropzone version > 14.2.3, file.path will add prefix ./  . So need to use file.name
            file.DESCRIPTION = file.lastModified; // not used
            /*  file.REQ_ID = this.props.request_id; */

            let newFile = {
              //CHG_DATE: file.lastModified,
              CHG_DATE: usedate,
              FILE_CONTENT: file.FILE_CONTENT,
              FILE_NAME: file.name, //after upgrade to Node24, react-dropzone version > 14.2.3, file.path will add prefix ./  . So need to use file.name
              FILE_NUM: file_num,
              FILE_TYPE: "pdf"
            };

            //uploadedfiles.push( file );
            uploadedfiles.push( newFile );
            if (ctr == cnt) {
              dispatch(vendordata_updateFiles({files:uploadedfiles}));

              /* updateFromLa(uploadedfiles); */
            }
            ctr++;
            file_num++;


          };
          /* reader.readAsArrayBuffer(file); */
          reader.readAsDataURL(file);
        }


      }
    });
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onDrop,
    maxSize: 50000000
  });

  const fileUploadComplete = files => {};

  //TODO: show submitfeedback on fileuploader
  return (
    <div
      {...getRootProps()}
      className="mt-5 d-flex justify-content-center align-items-center"
      style={{
        cursor: "pointer",
        border: "2px solid",
        borderColor:
          /* props.submitState.showsubmitfeedback && */ Object.keys(
            vendordata.files
          ).length < 1
            ? "gray"
            : "black",
        backgroundColor: "#ffffff",
        maxWidth: 400,
        minWidth: 200,
        minHeight: 100
      }}
    >
      <input {...getInputProps()} />
      <div>Upload PDF('s)</div>
    </div>
  );
}

export default FileUploader;
